import noop from 'lodash.noop';

const alwaysNoop = () => noop;

export default alwaysNoop;
